import { Component, OnInit, Input, Output, EventEmitter, ElementRef, Renderer2 } from '@angular/core';
import * as _ from "lodash";

@Component({
  selector: 'app-stoggle',
  templateUrl: './stoggle.component.html',
  styleUrls: ['./stoggle.component.css']
})
export class StoggleComponent implements OnInit {

  id: any;
  @Input() label: string = "";
  @Input() options: any[];
  selected: any;
  @Output() onSelectedOut = new EventEmitter<string>();

  constructor(private el: ElementRef, private r2: Renderer2) {

  }

  ngOnInit() {
    //console.log(this.el);
    //console.log(this.r2);
    this.id = 'stoggle-' + _.random(100, 8000);
  }

  onSelect(event, data) {
    let c = this.el.nativeElement.children[0].children;
    //console.log("childs: " + c.length);
    for (let i in c) {
      if (parseInt(i) > 0) {
        if (c[i].classList.contains("btn3")) {
          c[i].classList.remove("btn3");
        }
        if (!c[i].classList.contains("btn2")) {
          c[i].classList.add("btn2");
        }
      }
    }
    var target = event.target || event.srcElement || event.currentTarget;
    target.classList.remove("btn2");
    target.classList.add("btn3");
    /*var idAttr = target.attributes.id;
    var value = idAttr.nodeValue;
    console.log("data: "+JSON.stringify(idAttr)); */
    //let el1 = this.el.nativeElement.querySelector("#" + this.id + ':nth-child(2)');
    //console.log(event);
    //console.log(el1);
    //console.log("data: "+data);    
    this.onSelectedOut.emit(data);
  }

}



// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/stoggle/stoggle.component.ts